module.exports = __webpack_public_path__ + "static/media/prismport-5.8d4f0f45.jpg";